import { FC, PropsWithChildren } from "react";

export const BaseFooter: FC<PropsWithChildren<{ darkMode?: boolean }>> = ({
  children,
  darkMode,
}) => {
  return (
    <footer
      className="group/themable flex h-[--footer-height] w-full items-center rounded-b-none rounded-t-lg border-t border-t-black-tint-90 bg-white p-3 text-sm shadow-md data-[dark]:border-t-black-tint-15 data-[dark]:bg-black-tint-15"
      data-dark={darkMode || undefined}
    >
      {children}
    </footer>
  );
};
